<template>
    <!-- <ul class="list-group" id="myReqClinicTable">
        <template v-for="(item, index) in datalists" :key="item.ReqClinicID"> -->
            <li class="list-group-item text-dark list-group-item-warning py-0">
            <div class="container-fluid d-flex justify-content-between align-items-center px-0">
                <span>{{index+1}}.
                <button type="button" class="btn btn-outline-primary btn-sm mx-1 py-0 my-1" style="font-size:90%;" @click="btnPrintClinicSummary()">พิมพ์</button>
                <button type="button" class="btn btn-outline-secondary btn-sm mx-1 py-0 my-1" style="font-size:90%;" @click="toggleShowHideROInClinic()">{{capChildClinic}}</button>
                {{ item.ReqClinicName }}
                <span class="badge bg-white text-dark border ms-2" style="width:40px;" title="จำนวนคนไข้">{{ item.CntPat }} คน</span>
                </span>
                <span class="">
                <span class="badge bg-dark text-white border me-2" style="width:40px;" title="ใบสั่งตรวจทั้งหมด">{{ item.CntLN }}</span>
                <span class="badge bg-info text-white border" style="width:40px;" title="ใบสั่งตรวจใหม่">{{ item.CntNew }}</span>
                <span class="badge bg-warning text-white border" style="width:40px;" title="ป้อนผล">{{ item.CntResult }}</span>
                <span class="badge bg-success text-white border" style="width:40px;" title="อนุมัติ">{{ item.CntAP }}</span>
                <span class="badge bg-danger text-white border mx-2" style="width:40px;" title="ยกเลิก">{{ item.CntCC }}</span>

                <span class="badge bg-success text-white border ms-2" style="width:80px;" title="รวมเป็นเงินสุทธิ">{{  numeralFormat(item.SumNetAmt, '0,0[.]00') }}</span>
                <span class="badge bg-danger text-white border " style="width:80px;" title="รับชำระแล้ว">{{ numeralFormat(item.SumRcptAmt, '0,0[.]00') }}</span>
                </span>
            </div>
            <!--  -->
            <!-- <div class="container list-group-item-warning px-0 mb-2" style="height:60px;max-height:100px;">
                <div class="mh-100 vh-100 overflow-auto border border-2 rounded p-0 ms-3"> -->
            <div class="container-fluid list-group-item-warning px-0 mb-2" style="" :hidden="!toggleShowHide">
                <RepDshSummary2ROClinic :key="countRefresh_ROClinic" v-if="countRefresh_ROClinic>0"
                    :bShowHide="toggleShowHide"
                    :curRecordReqClinic="item"
                    :docDateFm="docDateFm" :docDateTo="docDateTo" :BranchID="BranchID"
                    :Status0="Status0" :Status1="Status1" :Status2="Status2" :Status3="Status3"> </RepDshSummary2ROClinic>
            </div>

            <!-- <RepDshSummary1ROClinic :key="countRefresh_ROClinic"
                :curRecordReqClinic="item"
                :docDateFm="docDateFm" :docDateTo="docDateTo" :BranchID="BranchID"
                :Status0="Status0" :Status1="Status1" :Status2="Status2" :Status3="Status3"> </RepDshSummary1ROClinic> -->
            </li>
        <!-- </template>
    </ul> -->
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'
import RepDshSummary2ROClinic from './RepDshSummary2ROClinic.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepDshROClinic',
  components: {
    RepDshSummary2ROClinic
  },
  data () {
    return {
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrCancel: ['', 'C'],
      arrPaid: ['', 'P'],

      item: {}, // curRecordReqClinic
      datalistsROInReqClinic: [],
      countRefresh_ROClinic: 0,
      toggleShowHide: false
    }
  },
  computed: {
    // a computed getter
    capChildClinic () {
      return this.toggleShowHide ? 'v' : '>'
    }
  },
  created () {
    // Initial Value
  },
  props: ['index', 'bShowHide', 'curRecordReqClinic', 'docDateFm', 'docDateTo', 'BranchID', 'Status0', 'Status1', 'Status2', 'Status3'],
  mounted () {
    this.item = this.curRecordReqClinic
    // this.getData_ROInReqClinic()
    this.toggleShowHide = this.bShowHide
    this.countRefresh_ROClinic++
  },
  methods: {
    btnPrintClinicSummary () {
      Swal.fire({
        icon: 'info',
        title: 'กำลังอยู่ในช่วงพัฒนา..',
        showConfirmButton: false,
        timer: 1500
      })
    },
    toggleShowHideROInClinic () {
      this.toggleShowHide = !this.toggleShowHide
    },
    getData_ROInReqClinic () {
    //   var docDateFm = this.dateFm.toISOString().slice(0, 10)
    //   var docDateTo = this.dateTo.toISOString().slice(0, 10)
    //   var BranchID = this.branchSelected.BranchID // this.branchID
    //   var Status0 = -1 // 0-New
    //   var Status1 = -1 // 1-Lab
    //   var Status2 = -1 // 2-Resulted
    //   var Status3 = -1 // 3-Approve
    //   if (this.status0New) {
    //     Status0 = 0 // 0-New
    //   }
    //   if (this.status1Lab) {
    //     Status1 = 1 // 1-Lab
    //   }
    //   if (this.status2Res) {
    //     Status2 = 2 // 2-Resulted
    //   }
    //   if (this.status3App) {
    //     Status3 = 3 // 3-Approve
    //   }
      MyApiClient.get('getdata/repdsh_ro_where_clinic.php?C1=' + this.globalCorpID + '&BranchID=' + this.BranchID +
        '&DocDateFm=' + this.docDateFm + '&DocDateTo=' + this.docDateTo +
        '&Status0=' + this.Status0 + '&Status1=' + this.Status1 + '&Status2=' + this.Status2 +
        '&Status3=' + this.Status3 + '&ReqClinicID=' + this.curRecordReqClinic.ReqClinicID)
        .then((resp) => {
          console.log('getdata/repdsh_ro_where_clinic.php?C1=' + this.globalCorpID + '&BranchID=' + this.BranchID +
           '&DocDateFm=' + this.docDateFm + '&DocDateTo=' + this.docDateTo +
           '&Status0=' + this.Status0 + '&Status1=' + this.Status1 + '&Status2=' + this.Status2 +
           '&Status3=' + this.Status3 + '&ReqClinicID=' + this.curRecordReqClinic.ReqClinicID)
          console.log('After get by Cond.. RO in clinic ')
          console.log(this.countRefresh_ROClinic)
          console.log(resp.data.response)
          this.datalistsROInReqClinic = resp.data.response
          if (this.datalistsROInReqClinic == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล Clinic', showConfirmButton: false, timer: 1000 })
            this.datalistsROInReqClinic = []
          }
          //   this.$nextTick(() => {
          //     $('#myROReqClinicTable').DataTable()
          //   })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh_ROClinic++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
